// Global styles
import "@/assets/scss/main.scss";

// Importing Vue and other dependencies
import Vue from "vue";
import App from "./App.vue";
import VueGtag from "vue-gtag";
import router from "./router";
import store from "./store";
import globalConfig from "./mixins/globalConfig";
import "vue2-datepicker/index.css"
import "vue2-datepicker/locale/sv"
import "@/assets/css/main.css";

import VueObserveVisibility from "vue-observe-visibility";

//Importing Bootstrap handpicked plugins (for smaller app size)
import {
  ButtonPlugin,
  LayoutPlugin,
  NavbarPlugin,
  FormPlugin,
  FormInputPlugin,
  FormSelectPlugin,
  FormCheckboxPlugin,
  CardPlugin,
  FormGroupPlugin,
  ModalPlugin,
  ListGroupPlugin,
  TablePlugin,
  PaginationPlugin,
  TabsPlugin,
  SpinnerPlugin,
  FormRadioPlugin,
  ToastPlugin,
  TooltipPlugin,
  ProgressPlugin,
  DropdownPlugin,
  IconsPlugin,
  LinkPlugin,
  SidebarPlugin,
  ButtonGroupPlugin,
} from "bootstrap-vue";
import browserDetect from "vue-browser-detect-plugin";

// Use Vue plugins
Vue.use(ButtonGroupPlugin);
Vue.use(SidebarPlugin);
Vue.use(ButtonPlugin);
Vue.use(LayoutPlugin);
Vue.use(NavbarPlugin);
Vue.use(FormPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(CardPlugin);
Vue.use(FormGroupPlugin);
Vue.use(ModalPlugin);
Vue.use(ListGroupPlugin);
Vue.use(TablePlugin);
Vue.use(PaginationPlugin);
Vue.use(TabsPlugin);
Vue.use(SpinnerPlugin);
Vue.use(FormRadioPlugin);
Vue.use(ToastPlugin);
Vue.use(TooltipPlugin);
Vue.use(ProgressPlugin);
Vue.use(DropdownPlugin);
Vue.use(IconsPlugin);
Vue.use(LinkPlugin);
Vue.use(VueObserveVisibility);
Vue.use(browserDetect);

export const bus = new Vue();
import AppConstants from '@/constants/appConstants';
Vue.use(AppConstants);
Vue.config.productionTip = false;


// Fetch configuration and then initialize the app
store.dispatch("fetchConfig").then(() => {
  // Apply the globalConfig mixin globally
  Vue.mixin(globalConfig);

  // Initialize VueGtag with the config value
  const googleTagId = store.state.config.runtime?.GoogleTagId;
  if (googleTagId) {
    Vue.use(VueGtag, {
      config: { id: googleTagId },
    });
  }

  new Vue({
    render: (h) => h(App),
    store,
    router,
  }).$mount("#app");
});
